<div class="property-map" *ngIf="isMapsReady$ | async">
  <google-map width="100%"
              height="100%"
              [center]="{ lat: lat, lng: lng }"
              [options]="mapOptions"
              (mapInitialized)="onMapInitialized($event)">
  </google-map>
</div>
